import { useState, useEffect } from "react";

// Custom hook to check if the device is mobile
const useIsMobile = (): boolean => {
  // State to store whether the device is mobile
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

  useEffect(() => {
    // Function to check the screen width
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty dependency array ensures this runs once on mount

  return isMobile;
};

export default useIsMobile;
